const BASE_URL = 'ai-service/api/iteration-metrics'

const metricsRequests = {
  getMetricsByIterationIdRequest: (iterationId) => ({
    url: `${BASE_URL}/iteration/${iterationId}`,
    method: 'get',
  }),
  downloadIterationMetricsRequest: (iterationId) => ({
    url: `${BASE_URL}/iteration/${iterationId}/download`,
    method: 'post',
  }),
}

export default metricsRequests
